import { IRemotePage } from ".";
import { ElLoading } from "element-plus";

export class DemoIRemotePage extends IRemotePage {
  options = {};
  dataLog: any[] = [];
  async mounted() {
    const loader = ElLoading.service({ lock: true });
    this.dataLog = this.initialData;
    await this.builDataTable();
    loader.close();
  }

  get initialData() {
    return [
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
      [
        "GAS ANALYZER (6500160)",
        "01/03/2023 09:23:29",
        "01/03/2023 09:23:29",
        "Success",
      ],
    ];
  }

  async builDataTable() {
    this.options = {
      mobileView: {
        header: {
          title: function (data: any) {
            return data[0];
          },
        },
      },
      columns: [
        { mobileView: false },
        { mobileView: true },
        { mobileView: true },
        { mobileView: true },
      ],
      data: this.dataLog,
    };
  }

  searching() {
    console.log(this.adv);
  }
}
